export const ACCEPT_INVITATION_QUERY_PARAM_KEYS = {
  sourceOrganisationDisplayName: "sourceOrganisationDisplayName",
  projectName: "projectName",
  senderFirstName: "senderFirstName",
  senderLastName: "senderLastName",
} as const;

export const ACCEPT_INVITATION_QUERY_PARAM_LABELS: Record<string, string> = {
  [ACCEPT_INVITATION_QUERY_PARAM_KEYS.sourceOrganisationDisplayName]: "Source organisation",
  [ACCEPT_INVITATION_QUERY_PARAM_KEYS.projectName]: "Project name",
  [ACCEPT_INVITATION_QUERY_PARAM_KEYS.senderFirstName]: "Sender first name",
  [ACCEPT_INVITATION_QUERY_PARAM_KEYS.senderLastName]: "Sender last name",
};

export const ACCEPT_INVITATION_SHARED_QUERY_PARAM_KEYS = Object.values(ACCEPT_INVITATION_QUERY_PARAM_KEYS);
